import { render } from "./Tickets.vue?vue&type=template&id=0feb209e"
import script from "./Tickets.vue?vue&type=script&lang=js"
export * from "./Tickets.vue?vue&type=script&lang=js"

import "./Tickets.vue?vue&type=style&index=0&id=0feb209e&lang=scss"

import exportComponent from "/Users/patricksantner/projects/alpbach-ticketshop-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__